/**
 * menu.js — 汎用ディスクロージャ (ドロップダウン)。bootstrap dropdown の置換。
 *
 * マークアップ契約:
 *   [data-menu]
 *     [data-menu-toggle]           … 開閉ボタン (aria-expanded を自動管理)
 *     [data-menu-panel][hidden]    … パネル
 *
 * 外側クリック / Esc で閉じる。
 */
export function initMenu() {
  document.querySelectorAll('[data-menu]').forEach((menu) => {
    const toggle = menu.querySelector('[data-menu-toggle]');
    const panel = menu.querySelector('[data-menu-panel]');
    if (!toggle || !panel) return;

    const open = () => {
      menu.classList.add('is-open');
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      menu.classList.remove('is-open');
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      if (menu.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    close(); // 初期状態を確定
  });
}
